<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchShow" :gutter="16">
                <Col span="24">
                    <search-card
                        :form="mainTable.searchForm"
                        :table-load-event="getTableRecords"
                        :table-search="mainTable.tableSearch"
                    />
                </Col>
            </Row>
        </transition>
        <Card :padding="0" :bordered="false" :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">总监部门成员列表</span>
                        </div>
                        <div class="right-bar">
                            <Button
                                v-if="$checkAccessArray(['S'])"
                                size="small"
                                class="btns"
                                shape="circle"
                                type="success"
                                icon="ios-add-circle-outline"
                                @click="onCreate"
                                >新增(选择公司名称)</Button
                            >
                            <Button
                                v-if="$checkAccessArray(['S'])"
                                size="small"
                                class="btns"
                                shape="circle"
                                type="success"
                                icon="ios-add-circle-outline"
                                @click="onCreateWrite"
                                >新增(填写公司名称)</Button
                            >
                            <Button
                                type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                @click="
                                    mainTable.sarchShow = !mainTable.sarchShow
                                "
                                >搜索</Button
                            >
                        </div>
                    </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                    <stand-pagination-table
                        :columns="mainTable.columns"
                        :data="mainTable.data"
                        :extHeight="60"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getTableRecords"
                    />
                </Col>
            </Row>
        </Card>

        <DeptMemberInspectorEdit ref="DeptMemberInspectorModal" />
        <DeptMemberInspectorEditWriteCompany
            ref="DeptMemberInspectorEditWriteCompanyModal"
        />
    </div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import { statusNewFormat } from "@/libs/baseModelFormat";
import { dateRender } from "@/libs/tableRowTimeRender";
import DeptMemberInspectorEdit from "./dept-member-inspector-edit";
import DeptMemberInspectorEditWriteCompany from "./dept-member-inspector-edit-write-company";
import { getProjectList } from "@/api/modules/account-management/inspector-user-management";

export default {
    name: "DeptMemberInspectorList",
    components: {
        SearchCard,
        StandPaginationTable,
        DeptMemberInspectorEdit,
        DeptMemberInspectorEditWriteCompany
    },
    data() {
        return {
            mainTable: {
                columns: [
                    {
                        title: "行号",
                        type: "index",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "公司名称",
                        key: "projectCompany",
                        align: "center"
                    },
                    {
                        title: "部门名称",
                        key: "projectName",
                        align: "center"
                    },
                    {
                        title: "成员账号",
                        key: "projectCode",
                        align: "center"
                    },
                    {
                        title: "成员姓名",
                        key: "userPersonName",
                        align: "center"
                    },
                    {
                        title: "成员手机号",
                        key: "userPhone",
                        align: "center"
                    }
                ],
                data: [],
                sarchShow: false,
                searchForm: [
                    {
                        label: "公司名称",
                        type: "Input",
                        value: "",
                        name: "projectCompany",
                        sql: "like"
                    },
                    {
                        label: "部门名称",
                        type: "Input",
                        value: "",
                        name: "projectName",
                        sql: "like"
                    },
                    {
                        label: "账号/姓名",
                        type: "Input",
                        value: "",
                        name: "concat(projectCode, userPersonName)",
                        sql: "like"
                    }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getTableRecords();
    },
    methods: {
        getTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.belongTo = "总监";
            getProjectList(this.mainTable.tableSearch)
                .then((res) => {
                    if (res.code === 0) {
                        this.mainTable.data = res.data.records;
                        search.globalSetFilterRecordCount(
                            this.mainTable.tableSearch,
                            res.data.filterRecordCount
                        );
                    }

                    this.mainTable.loading = false;
                })
                .catch(() => {
                    this.mainTable.loading = false;
                });
        },
        onCreate() {
            this.$refs.DeptMemberInspectorModal.showModal("");
        },
        onCreateWrite() {
            this.$refs.DeptMemberInspectorEditWriteCompanyModal.showModal("");
        }
    }
};
</script>

<style scoped></style>
